import { FC, useCallback, useMemo } from 'react'
import { ISegmentedControlElementProps } from '@cargomart/ui'
import cn from 'classnames'
import IconOpenMail from 'remixicon/icons/Business/mail-open-line.svg?react'

export const CargoSizeControlMobileElement: FC<ISegmentedControlElementProps<string>> = ({
  selected,
  onClick,
  className,
  disabled,
  tabIndex,
  value,
  type = 'button',
  ...rest
}) => {
  const classes = useMemo(() => {
    if (disabled) {
      return cn(
        selected
          ? 'bg-state-on-surface-focused text-on-surface'
          : 'bg-state-on-surface-hover text-on-surface-variant/disabled'
      )
    }

    if (selected) {
      return 'bg-on-primary shadow-3 ring-sm z-10'
    }

    return 'text-on-surface-variant bg-surface-variant hover:bg-state-on-surface-variant-hover active:bg-state-on-surface-variant-active'
  }, [disabled, selected])

  const label = useMemo(() => {
    switch (value) {
      case 'envelope':
        return <IconOpenMail className="text-on-surface-variant" size="sm" />
      case 'package':
        return <div className="text-title-md">XS</div>
      case 'small':
        return <div className="text-title-md">S</div>
      case 'medium':
        return <div className="text-title-md">M</div>
      case 'large':
        return <div className="text-title-md">L</div>
      default:
        return <div className="text-title-md">{String(value)}</div>
    }
  }, [value])

  const handleClick = useCallback(() => {
    if (value !== undefined && onClick) {
      onClick(value)
    }
  }, [onClick, value])

  return (
    <button
      {...rest}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={handleClick}
      tabIndex={tabIndex}
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={cn(
        className,
        'inline-flex grow appearance-none flex-col items-center justify-between rounded-xl p-4 outline-none transition',
        classes,
        disabled ? 'cursor-not-allowed ' : 'cursor-pointer focus:z-10 focus:ring-sm'
      )}
    >
      {label}
    </button>
  )
}

export default CargoSizeControlMobileElement
